/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Close_Aria_LabelInputs */

const en_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close paste attributes modal`)
};

const fr_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la boite de dialogue de collage des attributs`)
};

const de_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal zum Einfügen von Attributen schließen`)
};

const it_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la finestra modale degli attributi di incolla`)
};

const ru_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно вставки атрибутов`)
};

const es_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modal de pegar atributos`)
};

const zh_cn2_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭粘贴属性模态框`)
};

const ja_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`属性貼り付けモーダルを閉じる`)
};

const hi_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट विशेषताओं को बंद करें मोडल`)
};

const pt_pt2_paste_attributes_close_aria_label = /** @type {(inputs: Paste_Attributes_Close_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal de atributos de colagem`)
};

/**
* | output |
* | --- |
* | "Close paste attributes modal" |
*
* @param {Paste_Attributes_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_close_aria_label = /** @type {((inputs?: Paste_Attributes_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_close_aria_label(inputs)
	if (locale === "de") return de_paste_attributes_close_aria_label(inputs)
	if (locale === "it") return it_paste_attributes_close_aria_label(inputs)
	if (locale === "ru") return ru_paste_attributes_close_aria_label(inputs)
	if (locale === "es") return es_paste_attributes_close_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_close_aria_label(inputs)
	if (locale === "ja") return ja_paste_attributes_close_aria_label(inputs)
	if (locale === "hi") return hi_paste_attributes_close_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_close_aria_label(inputs)
	return en_paste_attributes_close_aria_label(inputs)
});